"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
var _locales = require("../utils/locales");
const messages = exports.messages = {
  [_locales.locales.en]: {
    increment: "Increment count for:",
    decrement: "Decrement count for:"
  },
  [_locales.locales.es]: {
    increment: "Cuenta de incrementos para:",
    decrement: "Recuento de decrementos para:"
  },
  [_locales.locales.fr]: {
    increment: "Nombre d'incréments pour:",
    decrement: "Décrémenter le compte pour:"
  },
  [_locales.locales.pt]: {
    increment: "Contagem de incremento para:",
    decrement: "Contagem de decremento para:"
  },
  [_locales.locales.zh]: {
    increment: "增量計數:",
    decrement: "遞減計數:"
  },
  [_locales.locales.de]: {
    increment: "Zählwert erhöhen für:",
    decrement: "Zählwert verringern für:"
  },
  [_locales.locales.it]: {
    increment: "Conteggio incrementale per:",
    decrement: "Conteggio decrementale per:"
  },
  [_locales.locales.ja]: {
    increment: "カウントを増やす:",
    decrement: "カウントを減らす:"
  },
  [_locales.locales.tl]: {
    increment: "Bilang ng pagtaas para sa:",
    decrement: "Bilang ng pagbabawas para sa:"
  },
  [_locales.locales.hi]: {
    increment: "वृद्धि की गणना निम्न के लिए:",
    decrement: "घटाई की गणना निम्न के लिए:"
  },
  [_locales.locales.ko]: {
    increment: "증가 수를 세다:",
    decrement: "감소 수를 세다:"
  }
};